import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'shared/components/modals/Modal';
import PriceChart from './PriceChart';
import Button from 'shared/components/Button';
import { AlarmIcon } from 'shared/components/Icons';

const PriceChartModal = ({ onClose, product, onSetPriceAlert }) => {
  const hasPriceAlert = !!product.priceAlert;
  const { t } = useTranslation();
  return (
    <Modal
      isOpen={true}
      className={`manage-modal d-flex flex-column justify-content-between mx-8`}
      onCloseModal={onClose}
    >
      <div className='px-30 py-28'>
        <h1 className={`mb-12 mb-md-15`}>{t('price_development')}</h1>
        <PriceChart product={product} hideTitle={true} hideFilter={false} />
        <div className='mt-10 d-flex align-items-center'>
          <p className='mb-0 fw-500'>{t('price_to_high')}</p>
          <Button
            className='btn-outline-primary btn-outline-fixed ml-md-15 py-2 py-md-4 ml-10 btn-sm'
            onClick={onSetPriceAlert}
          >
            <AlarmIcon className='mr-4' />
            {hasPriceAlert ? t('btn_edit_price_alarm') : t('btn_set_price_alarm')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default PriceChartModal;
